import * as React from "react";

import HotelIcon from "@mui/icons-material/Hotel";
import { Chip } from "@mui/material";

import { ApiHotelItem } from "@/api/hotel";
import useThemeData from "@/hooks/useThemeData";

function Pin(props: { active: boolean; data: ApiHotelItem }) {
  const { active = false, data } = props;

  const theme = useThemeData();
  const pointRate = data.book_info ? data.book_info.points_rate : data.points_median;
  const pointRateStr = Number(pointRate).toLocaleString('en-US');
  return (
    <div className="flex flex-col items-center">
      <Chip
        sx={{
          paddingX: "5px",
          transition: "none",
          ...(active
            ? {}
            : {
              backgroundColor: "#fff",
              border: `1px solid ${theme.palette.primary.main}`,
            }),
        }}
        size={active ? "medium" : "small"}
        icon={<HotelIcon sx={{ fontSize: "18px" }} />}
        color="primary"
        // label={`$${data.cash_min}`}
        label={`${pointRateStr}`}
        {...(active ? {} : { variant: "outlined" })}
      />
      <svg
        height="10"
        style={{
          transform: "translateY(-2px)",
        }}
        viewBox="0 0 19 10"
        width="19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          d="M19 0H0V1C4.96608 1 6.48058 4.29808 7.56473 6.65901C8.16909 7.97511 8.63973 9 9.5 9C10.36 9 10.8296 7.97578 11.4327 6.66029C12.5153 4.29927 14.028 1 19 1V0Z"
          fillRule="evenodd"
          style={{
            stroke: "none",
            fill: active ? theme.palette.primary.main : "#fff",
          }}
        />
        <path
          style={{
            fill: active ? theme.palette.primary.main : theme.palette.primary.main,
          }}
          clipRule="evenodd"
          d="M4.69717 2.34115C3.53936 1.5261 2.02621 1 0 1L0 2C1.84101 2 3.14853 2.4739 4.12153 3.15885C5.10147 3.84869 5.77723 4.77728 6.31171 5.74226C6.57907 6.22496 6.80787 6.71064 7.02314 7.17795C7.05209 7.24079 7.08089 7.30353 7.10958 7.36602C7.29114 7.76148 7.46816 8.14704 7.64789 8.48485C7.85468 8.87352 8.08687 9.24233 8.37256 9.51681C8.66993 9.80251 9.04121 10 9.5 10C9.95883 10 10.33 9.80247 10.6273 9.51666C10.9128 9.24211 11.1447 8.87323 11.3512 8.48457C11.5304 8.14712 11.707 7.762 11.888 7.367C11.9169 7.30409 11.9458 7.24094 11.9749 7.17769C12.1899 6.71041 12.4183 6.22475 12.6854 5.7421C13.2194 4.77721 13.8949 3.84869 14.8751 3.1589C15.8484 2.47397 17.1569 2 19 2V1C16.9719 1 15.4578 1.52603 14.2996 2.3411C13.1483 3.15131 12.3833 4.22279 11.8105 5.2579C11.5242 5.77525 11.2827 6.28959 11.0664 6.75981C11.0362 6.82545 11.0066 6.89001 10.9775 6.95348C10.7951 7.35123 10.6324 7.70599 10.468 8.01543C10.2761 8.37677 10.1036 8.63289 9.93415 8.79584C9.77641 8.94753 9.64204 9 9.5 9C9.35792 9 9.22337 8.94749 9.06537 8.79569C8.89569 8.63267 8.72296 8.37648 8.53072 8.01515C8.3659 7.70537 8.20275 7.35015 8.01982 6.95187C7.99087 6.88884 7.96143 6.82473 7.9314 6.75955C7.7148 6.28936 7.47302 5.77504 7.18649 5.25774C6.61322 4.22272 5.84804 3.15131 4.69717 2.34115Z"
          fillRule="evenodd"
        />
      </svg>
    </div>
  );
}

export default React.memo(Pin);
